import { FC } from 'react';
import { ChevronRight } from '@ixigo/icons';
import Typography from '@ixigo/iui/Typography';

interface HistoryItem {
    id: string;
    title: string;
    subtitle: string;
    summary?: string;
}

interface HistoryCardProps {
    title: string;
    items: HistoryItem[];
    onItemClick: (item: HistoryItem, index: number) => void;
    showSummary?: boolean;
}

const HistoryCard: FC<HistoryCardProps> = ({ title, items, onItemClick, showSummary = false }) => {
    if (!items || items.length === 0) return null;

    return (
        <div className='bg-white rounded-20 p-20 border border-gray-300 mb-20'>
            <div className='flex justify-between items-center mb-20'>
                <Typography variant='body-md' fontWeight='medium' className='text-charcoal-800 font-size-14'>
                    {title}
                </Typography>
            </div>

            <div className='space-y-3'>
                {items.map((item, index) => (
                    <button
                        key={item.id}
                        onClick={() => onItemClick(item, index)}
                        className='w-full flex items-center justify-between p-3 hover:bg-gray-50 rounded-lg transition-colors text-left'
                        type='button'
                    >
                        <div className='flex-1'>
                            <Typography variant='body-md' className='text-charcoal-800 mb-1'>
                                {item.title}
                            </Typography>
                            <Typography variant='body-sm' className='text-charcoal-600'>
                                {item.subtitle}
                            </Typography>
                            {showSummary && item.summary && (
                                <Typography variant='body-sm' className='text-charcoal-600 line-clamp-2 mt-1'>
                                    {item.summary}
                                </Typography>
                            )}
                        </div>
                        <ChevronRight className='w-20 h-20 text-charcoal-800 flex-shrink-0' />
                    </button>
                ))}
            </div>
        </div>
    );
};

export default HistoryCard;
